import { default as indexTRQ6D4mVJyMeta } from "/app/apps/explorer/pages/accounts/[address]/index/contract-code/index.vue?macro=true";
import { default as indexYswq0aW5pYMeta } from "/app/apps/explorer/pages/accounts/[address]/index/internal-transactions/index.vue?macro=true";
import { default as indexPddgr3mTEgMeta } from "/app/apps/explorer/pages/accounts/[address]/index/nft-transfers/index.vue?macro=true";
import { default as indexk6mWcmkde1Meta } from "/app/apps/explorer/pages/accounts/[address]/index/portfolio/nfts/index.vue?macro=true";
import { default as indexlqCaSoGhPHMeta } from "/app/apps/explorer/pages/accounts/[address]/index/portfolio/tokens/index.vue?macro=true";
import { default as indexJqboS4KMrvMeta } from "/app/apps/explorer/pages/accounts/[address]/index/token-transfers/index.vue?macro=true";
import { default as indexlDNGecBWEEMeta } from "/app/apps/explorer/pages/accounts/[address]/index/transactions/index.vue?macro=true";
import { default as indexBqtNKZmB4qMeta } from "/app/apps/explorer/pages/accounts/[address]/index.vue?macro=true";
import { default as index1wIz7oQGMmMeta } from "/app/apps/explorer/pages/accounts/index.vue?macro=true";
import { default as indexNtdCjXBINjMeta } from "/app/apps/explorer/pages/analytics/chart/[chartName]/index.vue?macro=true";
import { default as indexi5beDwCkCiMeta } from "/app/apps/explorer/pages/analytics/index/marketplace/index.vue?macro=true";
import { default as indexlkky5gl9DmMeta } from "/app/apps/explorer/pages/analytics/index/network/index.vue?macro=true";
import { default as indexG5PVyKlV7qMeta } from "/app/apps/explorer/pages/analytics/index/token/index.vue?macro=true";
import { default as indexvCBgqURLDpMeta } from "/app/apps/explorer/pages/analytics/index/user/index.vue?macro=true";
import { default as indexW5UkgXoLBhMeta } from "/app/apps/explorer/pages/analytics/index.vue?macro=true";
import { default as indexomE7R7KbTQMeta } from "/app/apps/explorer/pages/blocks/[blockNumber]/index/block/index.vue?macro=true";
import { default as indexLFRrf4nVJMMeta } from "/app/apps/explorer/pages/blocks/[blockNumber]/index/internal-transactions/index.vue?macro=true";
import { default as index6SE1Eq8BDEMeta } from "/app/apps/explorer/pages/blocks/[blockNumber]/index/transactions/index.vue?macro=true";
import { default as indexdUdqX29P8EMeta } from "/app/apps/explorer/pages/blocks/[blockNumber]/index.vue?macro=true";
import { default as indexEBKDx40lIFMeta } from "/app/apps/explorer/pages/blocks/index.vue?macro=true";
import { default as indexBlV7hlQ79RMeta } from "/app/apps/explorer/pages/deployed-contracts/index.vue?macro=true";
import { default as indexP49tIHL5EdMeta } from "/app/apps/explorer/pages/faq/index.vue?macro=true";
import { default as indexA8bQ2g4QaNMeta } from "/app/apps/explorer/pages/index.vue?macro=true";
import { default as index4p1yJLLvIMMeta } from "/app/apps/explorer/pages/maintenance/index.vue?macro=true";
import { default as indexRpIIdpZVRMMeta } from "/app/apps/explorer/pages/nfts/[tokenType]/[address]/[tokenId]/index/contract-code/index.vue?macro=true";
import { default as indexyQ43YxaMgIMeta } from "/app/apps/explorer/pages/nfts/[tokenType]/[address]/[tokenId]/index/holders/index.vue?macro=true";
import { default as indexafEXQk6stLMeta } from "/app/apps/explorer/pages/nfts/[tokenType]/[address]/[tokenId]/index/transfers/index.vue?macro=true";
import { default as indexsUXWNgtfh8Meta } from "/app/apps/explorer/pages/nfts/[tokenType]/[address]/[tokenId]/index.vue?macro=true";
import { default as indexLFOikGWBN7Meta } from "/app/apps/explorer/pages/nfts/[tokenType]/[address]/index/contract-code/index.vue?macro=true";
import { default as indexEuMl2VlB5CMeta } from "/app/apps/explorer/pages/nfts/[tokenType]/[address]/index/holders/index.vue?macro=true";
import { default as indexiG9c07XYpyMeta } from "/app/apps/explorer/pages/nfts/[tokenType]/[address]/index/info/index.vue?macro=true";
import { default as indexfTXkuyEhmGMeta } from "/app/apps/explorer/pages/nfts/[tokenType]/[address]/index/inventory/index.vue?macro=true";
import { default as indexMYu9n30mECMeta } from "/app/apps/explorer/pages/nfts/[tokenType]/[address]/index/transfers/index.vue?macro=true";
import { default as index7qwSPuYsMRMeta } from "/app/apps/explorer/pages/nfts/[tokenType]/[address]/index.vue?macro=true";
import { default as indexkJ3hAxSsobMeta } from "/app/apps/explorer/pages/nfts/mints/index.vue?macro=true";
import { default as indexM3goOc57wbMeta } from "/app/apps/explorer/pages/nfts/trades/index.vue?macro=true";
import { default as indexS2cXthf7XaMeta } from "/app/apps/explorer/pages/nfts/transfers/index.vue?macro=true";
import { default as indexw1Ug93ayTQMeta } from "/app/apps/explorer/pages/term-of-service/index.vue?macro=true";
import { default as burn_45dashboardJgzKN2eaRnMeta } from "/app/apps/explorer/pages/tokenomics/burn-dashboard.vue?macro=true";
import { default as token_45supply_45dashboardUFUb77St2AMeta } from "/app/apps/explorer/pages/tokenomics/token-supply-dashboard.vue?macro=true";
import { default as indexVqw8CxpyCLMeta } from "/app/apps/explorer/pages/tokens/[address]/index/contract-code/index.vue?macro=true";
import { default as indexyMfSq30QDyMeta } from "/app/apps/explorer/pages/tokens/[address]/index/holders/index.vue?macro=true";
import { default as indexCm7AHQIkg7Meta } from "/app/apps/explorer/pages/tokens/[address]/index/info/index.vue?macro=true";
import { default as indexz0jECwKf2pMeta } from "/app/apps/explorer/pages/tokens/[address]/index/transfers/index.vue?macro=true";
import { default as indexfgVUgpMXQlMeta } from "/app/apps/explorer/pages/tokens/[address]/index.vue?macro=true";
import { default as indexRFk14UrTm4Meta } from "/app/apps/explorer/pages/tokens/index.vue?macro=true";
import { default as indexcew6EG7OJtMeta } from "/app/apps/explorer/pages/tokens/nxpc/index/holders/index.vue?macro=true";
import { default as index6XrGEp84aiMeta } from "/app/apps/explorer/pages/tokens/nxpc/index/info/index.vue?macro=true";
import { default as indexAhymJRvuDwMeta } from "/app/apps/explorer/pages/tokens/nxpc/index.vue?macro=true";
import { default as indexpUPBlUwbvvMeta } from "/app/apps/explorer/pages/transactions/[txnHash]/index/block/index.vue?macro=true";
import { default as indexnaaoWa7DvDMeta } from "/app/apps/explorer/pages/transactions/[txnHash]/index/internal-trace/index.vue?macro=true";
import { default as indexf9Caj3OtuCMeta } from "/app/apps/explorer/pages/transactions/[txnHash]/index/logs/index.vue?macro=true";
import { default as indexrJ9JPObm8qMeta } from "/app/apps/explorer/pages/transactions/[txnHash]/index/transaction/index.vue?macro=true";
import { default as indexXyTUEsiwg7Meta } from "/app/apps/explorer/pages/transactions/[txnHash]/index.vue?macro=true";
import { default as indexgWNBpXwekSMeta } from "/app/apps/explorer/pages/transactions/index.vue?macro=true";
import { default as indexxPiS4TbT4lMeta } from "/app/apps/explorer/pages/transactions/internal/index.vue?macro=true";
import { default as index8na1EI18IKMeta } from "/app/apps/explorer/pages/transactions/pending/index.vue?macro=true";
export default [
  {
    name: "accounts-address",
    path: "/accounts/:address()",
    component: () => import("/app/apps/explorer/pages/accounts/[address]/index.vue").then(m => m.default || m),
    children: [
  {
    name: "accounts-address-index-contract-code",
    path: "contract-code",
    component: () => import("/app/apps/explorer/pages/accounts/[address]/index/contract-code/index.vue").then(m => m.default || m)
  },
  {
    name: "accounts-address-index-internal-transactions",
    path: "internal-transactions",
    component: () => import("/app/apps/explorer/pages/accounts/[address]/index/internal-transactions/index.vue").then(m => m.default || m)
  },
  {
    name: "accounts-address-index-nft-transfers",
    path: "nft-transfers",
    component: () => import("/app/apps/explorer/pages/accounts/[address]/index/nft-transfers/index.vue").then(m => m.default || m)
  },
  {
    name: "accounts-address-index-portfolio-nfts",
    path: "portfolio/nfts",
    component: () => import("/app/apps/explorer/pages/accounts/[address]/index/portfolio/nfts/index.vue").then(m => m.default || m)
  },
  {
    name: "accounts-address-index-portfolio-tokens",
    path: "portfolio/tokens",
    component: () => import("/app/apps/explorer/pages/accounts/[address]/index/portfolio/tokens/index.vue").then(m => m.default || m)
  },
  {
    name: "accounts-address-index-token-transfers",
    path: "token-transfers",
    component: () => import("/app/apps/explorer/pages/accounts/[address]/index/token-transfers/index.vue").then(m => m.default || m)
  },
  {
    name: "accounts-address-index-transactions",
    path: "transactions",
    component: () => import("/app/apps/explorer/pages/accounts/[address]/index/transactions/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "accounts",
    path: "/accounts",
    component: () => import("/app/apps/explorer/pages/accounts/index.vue").then(m => m.default || m)
  },
  {
    name: "analytics-chart-chartName",
    path: "/analytics/chart/:chartName()",
    meta: indexNtdCjXBINjMeta || {},
    component: () => import("/app/apps/explorer/pages/analytics/chart/[chartName]/index.vue").then(m => m.default || m)
  },
  {
    name: "analytics",
    path: "/analytics",
    component: () => import("/app/apps/explorer/pages/analytics/index.vue").then(m => m.default || m),
    children: [
  {
    name: "analytics-index-marketplace",
    path: "marketplace",
    component: () => import("/app/apps/explorer/pages/analytics/index/marketplace/index.vue").then(m => m.default || m)
  },
  {
    name: "analytics-index-network",
    path: "network",
    component: () => import("/app/apps/explorer/pages/analytics/index/network/index.vue").then(m => m.default || m)
  },
  {
    name: "analytics-index-token",
    path: "token",
    component: () => import("/app/apps/explorer/pages/analytics/index/token/index.vue").then(m => m.default || m)
  },
  {
    name: "analytics-index-user",
    path: "user",
    component: () => import("/app/apps/explorer/pages/analytics/index/user/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "blocks-blockNumber",
    path: "/blocks/:blockNumber()",
    component: () => import("/app/apps/explorer/pages/blocks/[blockNumber]/index.vue").then(m => m.default || m),
    children: [
  {
    name: "blocks-blockNumber-index-block",
    path: "block",
    component: () => import("/app/apps/explorer/pages/blocks/[blockNumber]/index/block/index.vue").then(m => m.default || m)
  },
  {
    name: "blocks-blockNumber-index-internal-transactions",
    path: "internal-transactions",
    component: () => import("/app/apps/explorer/pages/blocks/[blockNumber]/index/internal-transactions/index.vue").then(m => m.default || m)
  },
  {
    name: "blocks-blockNumber-index-transactions",
    path: "transactions",
    component: () => import("/app/apps/explorer/pages/blocks/[blockNumber]/index/transactions/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "blocks",
    path: "/blocks",
    component: () => import("/app/apps/explorer/pages/blocks/index.vue").then(m => m.default || m)
  },
  {
    name: "deployed-contracts",
    path: "/deployed-contracts",
    component: () => import("/app/apps/explorer/pages/deployed-contracts/index.vue").then(m => m.default || m)
  },
  {
    name: "faq",
    path: "/faq",
    component: () => import("/app/apps/explorer/pages/faq/index.vue").then(m => m.default || m)
  },
  {
    name: "index",
    path: "/",
    component: () => import("/app/apps/explorer/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "maintenance",
    path: "/maintenance",
    meta: index4p1yJLLvIMMeta || {},
    component: () => import("/app/apps/explorer/pages/maintenance/index.vue").then(m => m.default || m)
  },
  {
    name: "nfts-tokenType-address-tokenId",
    path: "/nfts/:tokenType()/:address()/:tokenId()",
    component: () => import("/app/apps/explorer/pages/nfts/[tokenType]/[address]/[tokenId]/index.vue").then(m => m.default || m),
    children: [
  {
    name: "nfts-tokenType-address-tokenId-index-contract-code",
    path: "contract-code",
    component: () => import("/app/apps/explorer/pages/nfts/[tokenType]/[address]/[tokenId]/index/contract-code/index.vue").then(m => m.default || m)
  },
  {
    name: "nfts-tokenType-address-tokenId-index-holders",
    path: "holders",
    component: () => import("/app/apps/explorer/pages/nfts/[tokenType]/[address]/[tokenId]/index/holders/index.vue").then(m => m.default || m)
  },
  {
    name: "nfts-tokenType-address-tokenId-index-transfers",
    path: "transfers",
    component: () => import("/app/apps/explorer/pages/nfts/[tokenType]/[address]/[tokenId]/index/transfers/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "nfts-tokenType-address",
    path: "/nfts/:tokenType()/:address()",
    component: () => import("/app/apps/explorer/pages/nfts/[tokenType]/[address]/index.vue").then(m => m.default || m),
    children: [
  {
    name: "nfts-tokenType-address-index-contract-code",
    path: "contract-code",
    component: () => import("/app/apps/explorer/pages/nfts/[tokenType]/[address]/index/contract-code/index.vue").then(m => m.default || m)
  },
  {
    name: "nfts-tokenType-address-index-holders",
    path: "holders",
    component: () => import("/app/apps/explorer/pages/nfts/[tokenType]/[address]/index/holders/index.vue").then(m => m.default || m)
  },
  {
    name: "nfts-tokenType-address-index-info",
    path: "info",
    component: () => import("/app/apps/explorer/pages/nfts/[tokenType]/[address]/index/info/index.vue").then(m => m.default || m)
  },
  {
    name: "nfts-tokenType-address-index-inventory",
    path: "inventory",
    component: () => import("/app/apps/explorer/pages/nfts/[tokenType]/[address]/index/inventory/index.vue").then(m => m.default || m)
  },
  {
    name: "nfts-tokenType-address-index-transfers",
    path: "transfers",
    component: () => import("/app/apps/explorer/pages/nfts/[tokenType]/[address]/index/transfers/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "nfts-mints",
    path: "/nfts/mints",
    component: () => import("/app/apps/explorer/pages/nfts/mints/index.vue").then(m => m.default || m)
  },
  {
    name: "nfts-trades",
    path: "/nfts/trades",
    component: () => import("/app/apps/explorer/pages/nfts/trades/index.vue").then(m => m.default || m)
  },
  {
    name: "nfts-transfers",
    path: "/nfts/transfers",
    component: () => import("/app/apps/explorer/pages/nfts/transfers/index.vue").then(m => m.default || m)
  },
  {
    name: "term-of-service",
    path: "/term-of-service",
    component: () => import("/app/apps/explorer/pages/term-of-service/index.vue").then(m => m.default || m)
  },
  {
    name: "tokenomics-burn-dashboard",
    path: "/tokenomics/burn-dashboard",
    component: () => import("/app/apps/explorer/pages/tokenomics/burn-dashboard.vue").then(m => m.default || m)
  },
  {
    name: "tokenomics-token-supply-dashboard",
    path: "/tokenomics/token-supply-dashboard",
    component: () => import("/app/apps/explorer/pages/tokenomics/token-supply-dashboard.vue").then(m => m.default || m)
  },
  {
    name: "tokens-address",
    path: "/tokens/:address()",
    component: () => import("/app/apps/explorer/pages/tokens/[address]/index.vue").then(m => m.default || m),
    children: [
  {
    name: "tokens-address-index-contract-code",
    path: "contract-code",
    component: () => import("/app/apps/explorer/pages/tokens/[address]/index/contract-code/index.vue").then(m => m.default || m)
  },
  {
    name: "tokens-address-index-holders",
    path: "holders",
    component: () => import("/app/apps/explorer/pages/tokens/[address]/index/holders/index.vue").then(m => m.default || m)
  },
  {
    name: "tokens-address-index-info",
    path: "info",
    component: () => import("/app/apps/explorer/pages/tokens/[address]/index/info/index.vue").then(m => m.default || m)
  },
  {
    name: "tokens-address-index-transfers",
    path: "transfers",
    component: () => import("/app/apps/explorer/pages/tokens/[address]/index/transfers/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "tokens",
    path: "/tokens",
    component: () => import("/app/apps/explorer/pages/tokens/index.vue").then(m => m.default || m)
  },
  {
    name: "tokens-nxpc",
    path: "/tokens/nxpc",
    component: () => import("/app/apps/explorer/pages/tokens/nxpc/index.vue").then(m => m.default || m),
    children: [
  {
    name: "tokens-nxpc-index-holders",
    path: "holders",
    component: () => import("/app/apps/explorer/pages/tokens/nxpc/index/holders/index.vue").then(m => m.default || m)
  },
  {
    name: "tokens-nxpc-index-info",
    path: "info",
    component: () => import("/app/apps/explorer/pages/tokens/nxpc/index/info/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "transactions-txnHash",
    path: "/transactions/:txnHash()",
    component: () => import("/app/apps/explorer/pages/transactions/[txnHash]/index.vue").then(m => m.default || m),
    children: [
  {
    name: "transactions-txnHash-index-block",
    path: "block",
    component: () => import("/app/apps/explorer/pages/transactions/[txnHash]/index/block/index.vue").then(m => m.default || m)
  },
  {
    name: "transactions-txnHash-index-internal-trace",
    path: "internal-trace",
    component: () => import("/app/apps/explorer/pages/transactions/[txnHash]/index/internal-trace/index.vue").then(m => m.default || m)
  },
  {
    name: "transactions-txnHash-index-logs",
    path: "logs",
    component: () => import("/app/apps/explorer/pages/transactions/[txnHash]/index/logs/index.vue").then(m => m.default || m)
  },
  {
    name: "transactions-txnHash-index-transaction",
    path: "transaction",
    component: () => import("/app/apps/explorer/pages/transactions/[txnHash]/index/transaction/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "transactions",
    path: "/transactions",
    meta: indexgWNBpXwekSMeta || {},
    component: () => import("/app/apps/explorer/pages/transactions/index.vue").then(m => m.default || m)
  },
  {
    name: "transactions-internal",
    path: "/transactions/internal",
    component: () => import("/app/apps/explorer/pages/transactions/internal/index.vue").then(m => m.default || m)
  },
  {
    name: "transactions-pending",
    path: "/transactions/pending",
    component: () => import("/app/apps/explorer/pages/transactions/pending/index.vue").then(m => m.default || m)
  }
]